
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServerMailTabs"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manageServerMail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manageServerVirusProtection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manageServerSpamFilter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manageServerMailAutodiscover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manageServerMailBlackWhiteLists"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"capability"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailServer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDomainsBlacklistSupported"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSmtpWhiteListSupported"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSmarthostAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isLocal"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAntiVirusInstalled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSpamAssassinInstalled"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"os"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isWindows"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryKey"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pleskKeyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyDrWeb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyQmailQueue"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":707}};
    doc.loc.source = {"body":"query ServerMailTabs {\r\n    viewer {\r\n        login\r\n        permissions {\r\n            manageServerMail\r\n            manageServerVirusProtection\r\n            manageServerSpamFilter\r\n            manageServerMailAutodiscover\r\n            manageServerMailBlackWhiteLists\r\n        }\r\n    }\r\n    capability {\r\n        mailServer {\r\n            isDomainsBlacklistSupported\r\n            isSmtpWhiteListSupported\r\n            isSmarthostAvailable\r\n            isLocal\r\n        }\r\n        packages {\r\n            isAntiVirusInstalled\r\n            isSpamAssassinInstalled\r\n        }\r\n    }\r\n    os {\r\n        isWindows\r\n    }\r\n    primaryKey {\r\n        pleskKeyId\r\n        keyDrWeb\r\n        keyQmailQueue\r\n    }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ServerMailTabs"] = oneQuery(doc, "ServerMailTabs");
        
